import { useState } from 'react'

import { apiInstance } from './apiInstance'

export const usePost = () => {
  const [responseStatus, setResponseStatus] = useState<number>()
  // const [res, setRes] = useState<any>()

  const axiosPost = async (postUrl: string, postData: object) => {
    apiInstance
      .post(postUrl, postData)
      .then((response) => {
        setResponseStatus(response.status)
      })
      .catch((error) => {
        // console.error('■ status', error.response.status)
        setResponseStatus(error?.response?.status)
      })
  }
  return { axiosPost, responseStatus }
}